import styled from 'styled-components/macro';
import Select from 'react-select';
import media from '../../styles/media';
import { fontSize } from '../../styles/mixins';

export const Autocomplete = styled(Select)`
  .autocomplete__control {
    max-height: 120px;
    height: 50px;
    border-radius: 0;
    padding-left: 10px;
    ${media.desktop`
      padding-left: 19px;
    `}
    border: 1px solid
      ${({ theme, invalid }) =>
        invalid ? theme.invalidColor : theme.validInputBorder};
    :hover {
      border: 1px solid ${({ theme }) => theme.validInputBorder};
    }
  }

  .autocomplete__value-container {
    padding: 0;
    ${fontSize(12)};
    ${media.desktop`
      ${fontSize(14)};
    `}
    top: 7px;
  }
  .autocomplete__single-value {
    color: ${({ theme, invalid }) =>
      invalid ? theme.invalidColor : theme.placeholderColor};
    font-weight: 500;
    margin: 0;
  }
  .autocomplete__input{
    color: ${({ theme, invalid }) =>
      invalid ? theme.invalidColor : theme.inputTextColor};

  }
  .autocomplete__indicator-separator {
    display: none;
  }
  .autocomplete__indicator {
    color: ${({ theme, invalid }) =>
      invalid ? theme.invalidColor : theme.placeholderColor};
  }
  .autocomplete__menu {
    margin-top: 2px;
  }
`;

export const AutocompleteContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: baseline;
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.invalidColor};
  padding-top: 10px;
  ${fontSize(10)};
`;
